export default __webpack_public_path__ + "static/media/person-1.91bbc9f1.jpg";